import * as tslib_1 from "tslib";
import { Popover, PopoverTabs } from '@nextiva/next-ui';
import { isEmpty } from 'lodash';
import * as React from 'react';
import { Tab, TabList, TabPanel } from 'react-tabs';
import Selectable from '../../PopoverSelectables/Selectable';
import SetsSelectable from '../../PopoverSelectables/SetsSelectable';
import { FunnelSvg } from '../../SvgIcons';
import CreateNewFilterButton from './CreateNewFilterButton';
import Styles from "./SaveableFiltersPopover.css";

var SaveableFiltersPopover =
/** @class */
function (_super) {
  tslib_1.__extends(SaveableFiltersPopover, _super);

  function SaveableFiltersPopover() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isOpen: false,
      selectedIndex: 0,
      shouldShowNewFilters: false
    };

    _this.togglePopover = function () {
      _this.setState(function (state) {
        return {
          isOpen: !state.isOpen,
          shouldShowNewFilters: false
        };
      });
    };

    _this.goToTab = function (selectedIndex) {
      _this.setState({
        selectedIndex: selectedIndex,
        shouldShowNewFilters: false
      });
    };

    _this.goToNewFilters = function () {
      _this.setState({
        selectedIndex: 1,
        shouldShowNewFilters: true
      });
    };

    return _this;
  }

  SaveableFiltersPopover.prototype.render = function () {
    var _a = this.props,
        disabled = _a.disabled,
        filtersProps = _a.filtersProps,
        savedFiltersProps = _a.savedFiltersProps,
        onCreateFilterSet = _a.onCreateFilterSet;
    var _b = this.state,
        isOpen = _b.isOpen,
        selectedIndex = _b.selectedIndex,
        shouldShowNewFilters = _b.shouldShowNewFilters;
    var isActive = !isEmpty(filtersProps.selectedOptions) || isOpen;
    return React.createElement(Popover, {
      className: Styles.saveableFiltersPopover,
      openOnClick: !disabled,
      isOpen: isOpen,
      togglePopover: this.togglePopover,
      body: React.createElement(PopoverTabs, {
        selectedIndex: selectedIndex,
        onSelect: this.goToTab,
        className: Styles.tabs
      }, React.createElement(TabList, {
        className: ['react-tabs__tab-list', Styles.list]
      }, React.createElement(Tab, null, "Filter"), React.createElement(Tab, null, "Saved")), React.createElement(TabPanel, {
        className: ['react-tabs__tab-panel', Styles.panel]
      }, React.createElement(Selectable, tslib_1.__assign({
        title: "Filter Type",
        withCategories: true,
        beforeCategoriesList: React.createElement(CreateNewFilterButton, {
          onClick: this.goToNewFilters
        }),
        togglePopover: this.togglePopover,
        theme: {
          selectableBody: Styles.body
        }
      }, filtersProps))), React.createElement(TabPanel, {
        className: ['react-tabs__tab-panel', Styles.panel]
      }, shouldShowNewFilters ? React.createElement(Selectable, {
        selectedOptions: {},
        editable: true,
        withCategories: true,
        options: filtersProps.options,
        togglePopover: this.togglePopover,
        handlerSubmit: onCreateFilterSet,
        submitText: "Create and Submit",
        theme: {
          selectableBody: Styles.body
        }
      }) : React.createElement(SetsSelectable, tslib_1.__assign({
        categories: filtersProps.options,
        beforeCategorySets: React.createElement(CreateNewFilterButton, {
          onClick: this.goToNewFilters
        }),
        goToTab: this.goToTab,
        togglePopover: this.togglePopover
      }, savedFiltersProps))))
    }, React.createElement(FunnelSvg, {
      disabled: disabled,
      isActive: isActive
    }));
  };

  SaveableFiltersPopover.defaultProps = {
    filtersProps: {}
  };
  return SaveableFiltersPopover;
}(React.Component);

export default SaveableFiltersPopover;